import React from "react";
import { Hyperlink, PlateNumber } from "@racoon/ui";

/**
 * A truck's plate in the shift registry: the platform's plate chip, linked to
 * the truck on the dashboard map when there is a truck to open. Without `onOpen`
 * (or a truck id) it is the bare chip.
 */
export const ShiftPlate: React.FC<{
  plateNumber: string;
  truckId?: bigint;
  onOpen?: (truckId: bigint) => void;
}> = ({ plateNumber, truckId, onOpen }) =>
  onOpen && truckId != null ? (
    <Hyperlink onOpen={() => onOpen(truckId)}>
      <PlateNumber plateNumber={plateNumber} />
    </Hyperlink>
  ) : (
    <PlateNumber plateNumber={plateNumber} />
  );
